module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00442.c6fd9562.jpg";